export function getIsDateToday(timestamp: number, isUnix = true) {
    const today = new Date().setHours(0, 0, 0, 0);
    const givenDay = new Date(isUnix ? timestamp * 1000 : timestamp).setHours(0, 0, 0, 0);
    return today === givenDay;
}
